import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { ClearAllMapDevicesData } from '@/OptimusRoutes/components/mapDevices/store/actions';
import { LogOut } from './actions';

const Logout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const refreshToken = useSelector((state) => state.auth.refreshToken);

	useEffect(() => {
		const performLogout = async () => {
			try {
				dispatch(ClearAllMapDevicesData());
				await dispatch(LogOut(refreshToken));
				navigate('/login', { replace: true });
			} catch (error) {
				navigate('/login', { replace: true });
			}
		};

		performLogout();
	}, [dispatch, navigate, refreshToken]);

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
			<Spin size="large" tip="Logging out..." />
		</div>
	);
};

export default Logout;
